import { render } from "./Inicio.vue?vue&type=template&id=5382fe0f"
import script from "./Inicio.vue?vue&type=script&lang=js"
export * from "./Inicio.vue?vue&type=script&lang=js"

import exportComponent from "/home/thales/Projetos/aceite-eletronico/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__